import { Button } from '@mui/material';
import { ChevronLeftIcon } from 'Components/designSystem';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ButtonBackToList({ listUri }: { listUri: string }) {
    const { t } = useTranslation('common');
    const navigate = useNavigate();

    const handleBackToList = () => {
        navigate(listUri);
    };

    return (
        <span>
            <Button variant="text"
                startIcon={ <ChevronLeftIcon /> }
                onClick={ handleBackToList }
            >
                { t('backToList') }
            </Button>
        </span>
    );
}
